import { NgModule } from '@angular/core';
import { PublicRoutingModule } from './public-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HomeindexComponent } from '../homeindex/homeindex.component';
import { LoginComponent } from '../login/login.component';
import { SingnUpComponent } from '../singn-up/singn-up.component';
import { RestLoginComponent } from '../rest-login/rest-login.component';
import { ConditionUtilisationComponent } from '../condition-utilisation/condition-utilisation.component';
import { PConfidentialityComponent } from '../p-confidentiality/p-confidentiality.component';
import { OnlinegetwayComponent } from '../onlinegetway/OnlinegetwayComponent';
import { DevDeployDocsComponent } from './dev-deploy-docs/dev-deploy-docs.component';

@NgModule({
  declarations: [
    HomeindexComponent,
    LoginComponent,
    SingnUpComponent,
    RestLoginComponent,
    ConditionUtilisationComponent,
    PConfidentialityComponent,
    OnlinegetwayComponent,
    DevDeployDocsComponent
  ],
  imports: [SharedModule, PublicRoutingModule]
})
export class PublicModule { }
